import { render, staticRenderFns } from "./DbInfo.vue?vue&type=template&id=f450e83e&scoped=true"
import script from "./DbInfo.vue?vue&type=script&lang=js"
export * from "./DbInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f450e83e",
  null
  
)

export default component.exports